module.exports = __webpack_public_path__ + "static/bellclick3.a0e20ab4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/bellclick3.jpg
// module id = 1257
// module chunks = 35783957827783